export default "__VITE_ASSET__Bz7qbmV___"